<template>
  <v-data-table
    :headers="headers"
    :items="customSearch(groceries, headers, filters.search)"
    :items-per-page="-1"
    class="striped-table ordera-box-shadow mt-4"
    hide-default-footer
    disable-pagination
    mobile-breakpoint="0"
    :loading="loading.getDailyRestaurant"
  >
    <template v-slot:top>
      <v-overlay v-if="loading.getDailyRestaurant" :absolute="true">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </template>
    <template v-slot:item.num="{ item, index }">
      {{ item.menu !== $t("total") ? index + 1 : "" }}
    </template>

    <template v-slot:item.shift_one="{ item }">
      {{ translate(item.shift_one.toFixed(5)) }}
    </template>
    <template v-slot:item.shift_two="{ item }">
      {{ translate(item.shift_two.toFixed(5)) }}
    </template>
    <template v-slot:item.shift_three="{ item }">
      {{ translate(item.shift_three.toFixed(5)) }}
    </template>
    <template v-slot:item.shift_four="{ item }">
      {{ translate(item.shift_four.toFixed(5)) }}
    </template>
    <template v-slot:item.total="{ item }">
      {{ translate(item.total.toFixed(5)) }}
    </template>
  </v-data-table>
</template>

<script>
import reportService from "@/services/report";
import hasPrinting from "@/mixins/hasPrinting";
import hasReportPrinting from "@/mixins/report/hasReportPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  mixins: [hasPrinting, hasReportPrinting, hasExcel],
  name: "ReportMealsTabGroceries",
  data() {
    return {
      report: null,
      loading: {
        getDailyRestaurant: false,
      },
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("r_b"), value: "num" },
        { text: this.$t("grocery"), value: "menu" },
        { text: this.$t("1st_shift"), value: "shift_one" },
        { text: this.$t("2nd_shift"), value: "shift_two" },
        { text: this.$t("3rd_shift"), value: "shift_three" },
        { text: this.$t("4th_shift"), value: "shift_four" },
        { text: this.$t("total"), value: "total" },
      ];
    },
    groceries() {
      if (!this.report) return [];
      const groceryTotals = {};

      // Helper function to add quantities to the groceryTotals object
      const addGroceries = (shift, shiftKey) => {
        Object.values(shift).forEach((meal) => {
          meal.foods.forEach((food) => {
            food.groceries.forEach((grocery) => {
              const totalQuantity = grocery.quantity * meal.quantity; // Multiply by meal quantity
              if (!groceryTotals[grocery.name]) {
                groceryTotals[grocery.name] = {
                  menu: this.toLatin(grocery.name),
                  shift_one: 0,
                  shift_two: 0,
                  shift_three: 0,
                  shift_four: 0,
                  total: 0,
                };
              }
              groceryTotals[grocery.name][shiftKey] += totalQuantity;
              groceryTotals[grocery.name].total += totalQuantity;
            });
          });
        });
      };

      // Process each shift
      if (this.report["1-smena"]) {
        addGroceries(this.report["1-smena"], "shift_one");
      }
      if (this.report["2-smena"]) {
        addGroceries(this.report["2-smena"], "shift_two");
      }
      if (this.report["3-smena"]) {
        addGroceries(this.report["3-smena"], "shift_three");
      }
      if (this.report["4-smena"]) {
        addGroceries(this.report["4-smena"], "shift_four");
      }

      // Convert the groceryTotals object to an array and return it
      return Object.values(groceryTotals);
    },
    filters() {
      return this.$store.state.report.filters;
    },
    restaurantId() {
      return this.$store.state.restaurant?.id;
    },
  },
  methods: {
    async getDailyRestaurant() {
      if (this.loading.getDailyRestaurant) {
        console.warn(
          "Get daily restaurant operation already in progress, skipping duplicate request"
        );
        return;
      }

      if (!this.restaurantId) return;

      this.loading.getDailyRestaurant = true;

      const params = {
        date: this.filters.dates.from,
        date2: this.filters.dates.to,
      };

      try {
        const res = await reportService.getDailyRestaurant(this.restaurantId, params);
        this.report = res.data;
      } catch (error) {
        console.error("Error fetching daily restaurant report:", error);
      } finally {
        this.loading.getDailyRestaurant = false;
      }
    },
  },
  watch: {
    "filters.dates": {
      handler() {
        this.getDailyRestaurant();
      },
      deep: true,
      immediate: true,
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        const itemsWithNum = this.groceries.map((item, index) => ({
          ...item,
          num: index + 1,
        }));
        this.downloadExcel({
          fileName: [this.$t("report"), this.$t("groceri")].join(" ") + ".xlsx",
          sheets: [
            {
              name: this.$t("groceri"),
              headers: this.headers,
              items: itemsWithNum,
              title: [this.$t("report"), this.$t("groceri")].join(" "),
              subtitle: this.subtitle,
            },
          ],
        });
      }
    },
    isPrinting() {
      if (this.isPrinting) {
        const itemsWithNum = this.groceries.map((item, index) => ({
          ...item,
          num: index + 1,
        }));
        this.printDocument({
          tables: [{ headers: this.headers, items: itemsWithNum, showCaption: true }],
          title: [this.$t("report"), this.$t("groceri")].join(": "),
          subtitle: this.subtitle,
          hideDatetime: true,
        });
      }
    },
  },
};
</script>
